import React from 'react';
import { Reveal } from './Reveal';
import { trustPoints } from '../data/trustPoints';
export function TrustSection() {
  return <section className="bg-brand-sandSoft px-4 py-20 md:py-28" data-id="element-181" data-mp="rvhs9hxxu3v9">
      <Reveal className="mx-auto max-w-6xl" data-id="element-182" data-mp="wmzltkxmt267">
        <div className="mb-12 text-center" data-id="element-183" data-mp="woayybcyvm9z">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-sageInk" data-id="element-184" data-mp="11mcewnf3j5h8">POURQUOI CE SYSTÈME</p>
          <h2 className="text-3xl font-black text-brand-slate md:text-4xl" data-id="element-185" data-mp="3zn9s4p3kcr5">
            Pourquoi les professeurs de Pilates Reformer choisissent ce système
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-2" data-id="element-186" data-mp="dxb3crayve7q">
          {trustPoints.map(({
          icon: TrustIcon,
          title,
          description
        }) => <article key={title} className="flex min-h-[180px] flex-col rounded-2xl border border-brand-sand bg-white p-7" data-id="element-187" data-mp="ix5soqf3fvqo">
              <TrustIcon className="h-6 w-6 text-brand-sage" strokeWidth={1.75} aria-hidden="true" data-id="element-188" data-mp="1ub1bqa94con6" />
              <h3 className="mt-5 font-serif text-xl font-bold leading-snug text-brand-slate" data-id="element-189" data-mp="2pvlejjz5q9ja">{title}</h3>
              <p className="mt-auto pt-4 text-sm leading-relaxed text-brand-gray" data-id="element-190" data-mp="2kw8ut83l1ikx">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}